import { combineEpics } from 'redux-observable';
import { catchError } from 'rxjs/operators';
import { activityEpic } from './activity';
import { alertsEpic } from './alerts';
import { archiveEpic } from './archive';
import { birthdaysEpic } from './birthdays';
import { contactsEpic } from './contacts';
import { groupsEpic } from './groups';
import { highlightsEpic } from './highlights';
import { localStoreEpic } from '@support/localStore';
import { locationsEpic } from './locations';
import { momentsEpic } from './moments';
import { nexusEpic } from './nexus';
import { notesEpic } from './notes';
import { reconnectEpic } from './reconnect';
import { searchEpic } from './search';
import { sharedDataEpics } from './shared';
import { shareStatusesEpics } from './shareStatuses';
import { sourcesEpic } from './sources';
import { starredEpic } from './starred';
import { timelineEpic } from './timeline';
import { uiEpic } from './ui';
import { userSettingsEpic } from './userSettings';
import { userEpic } from './user';
import { ReduxAction } from '../types';
import { Observable } from 'rxjs';
import { publicProfileEpic } from '@actions/publicProfile';
import { integrationsEpic } from './integrations';
import { groupActivityEpic } from './groupActivity';
import { csvImportEpics } from './csvImport';

const rootEpic = (action$: Observable<ReduxAction>, store$: any, dependencies: any) =>
  combineEpics(
    activityEpic,
    alertsEpic,
    archiveEpic,
    birthdaysEpic,
    contactsEpic,
    csvImportEpics,
    groupsEpic,
    groupActivityEpic,
    highlightsEpic,
    integrationsEpic,
    localStoreEpic,
    locationsEpic,
    momentsEpic,
    nexusEpic,
    notesEpic,
    publicProfileEpic,
    reconnectEpic,
    sharedDataEpics,
    shareStatusesEpics,
    searchEpic,
    sourcesEpic,
    starredEpic,
    timelineEpic,
    uiEpic,
    userSettingsEpic,
    userEpic,
  )(action$, store$, dependencies).pipe(
    // catchall error handling
    catchError((error, source) => {
      console.error(error);
      return source;
    }),
  );

export default rootEpic;
